export const getTags = (flyers) => {
  const tags = [];
  flyers.forEach((flyer) => {
    // console.log(flyer);
    flyer.intendedAudience.forEach((tag) => {
      if (tag !== "") {
        tags.push(tag);
      }
    });
  });
  // console.log(tags);
  return tags;
};

export const filterTags = (tags) => {
  //return unique tags
  return [...new Set(tags)];
};

export const filterFlyers = (flyers, tags) => {
  //   console.log(flyers);
  //   console.log(tags);
  if (tags.length === 0) {
    return flyers;
  }

  const filteredFlyers = flyers.filter((flyer) => {
    return flyer.intendedAudience.some((tag) => tags.includes(tag));
  });
  //   console.log(filteredFlyers);
  return filteredFlyers;
};
